import React from 'react';
import { Button } from './ui/button';
import { ArrowRight, Shield, CheckCircle, Clock, AlertTriangle } from 'lucide-react';
import { getTerminalSpotsLeft } from '../lib/urgency';

const NewFinalCTA = () => {
  const ctaLink = "https://calendly.com/davwaysolution/review";
  const spotsLeft = getTerminalSpotsLeft();

  return (
    <section className="py-20" style={{ backgroundColor: '#0B1F3A' }}>
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        {/* Urgency Banner */}
        <div className="inline-flex items-center gap-2 rounded-full px-6 py-3 mb-8" style={{ backgroundColor: 'rgba(255, 77, 45, 0.15)', border: '1px solid rgba(255, 77, 45, 0.4)' }}>
          <AlertTriangle size={18} style={{ color: '#FF4D2D' }} />
          <span className="font-bold" style={{ color: '#FF4D2D' }}>Only {spotsLeft} payment system spots left this month</span>
        </div>

        {/* Headline */}
        <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-white mb-6">
          If you're accepting cards,{' '}
          <span style={{ color: '#ef4444' }}>you're likely overpaying somewhere.</span>
        </h2>
        
        <p className="text-2xl text-gray-300 mb-10">
          Now you can actually <span style={{ color: '#D4AF37' }}>see it.</span>
        </p>

        {/* CTA Button */}
        <a href="/quick-check">
          <Button 
            className="text-white font-bold text-xl px-12 py-7 rounded-xl shadow-2xl hover:shadow-green-500/25 transition-all duration-300 hover:scale-105 group"
            style={{ backgroundColor: '#22C55E' }}
            data-testid="final-cta-btn"
          >
            Book My Walkthrough
            <ArrowRight className="ml-3 group-hover:translate-x-1 transition-transform" size={24} />
          </Button>
        </a>

        {/* Trust Signals */}
        <div className="flex flex-wrap justify-center gap-6 mt-10">
          <div className="flex items-center gap-2 text-gray-400">
            <Shield size={18} style={{ color: '#22C55E' }} />
            <span className="text-sm">Secure & Confidential</span>
          </div>
          <div className="flex items-center gap-2 text-gray-400">
            <CheckCircle size={18} style={{ color: '#22C55E' }} />
            <span className="text-sm">No Obligation</span>
          </div>
          <div className="flex items-center gap-2 text-gray-400">
            <Clock size={18} style={{ color: '#22C55E' }} />
            <span className="text-sm">Takes Less Than 2 Minutes</span>
          </div>
        </div>
      </div>
    </section>
  );
};

export default NewFinalCTA;
